module.exports = "/cyber/_next/static/images/awardsSlide-9ffc791b90753283ccaf34ddf1a78cfa.jpg";